export enum DEFAULT_TAG_TYPE {
  HOW_TO = 'How-To Videos',
  ADDITIONAL_RESOURCES = 'Additional Resources',
  ES_ADDITIONAL_RESOURCES = 'Documentos adicionales'
}
